import { getSvgIconName, GridContainer, SvgIcon } from '@bob/library'
import { calcBgAndFontColor } from '@websrc/App/Helpers/calcBgAndFontColor'
import { mapUniqueSellingPoints } from '@websrc/DataMappers/mapSpot'
import React from 'react'

import Heading from '../Heading/Heading'
import { sellingPoints } from './UniqueSellingPoints.css'

type UniqueSellingPointsProps = ReturnType<typeof mapUniqueSellingPoints> & {
  cta?: JSX.Element
  isTopOfPage?: boolean
}

export const UniqueSellingPoints: React.FC<UniqueSellingPointsProps> = ({
  description,
  headline,
  selling_points,
  cta,
  isTopOfPage,
}) => {
  return (
    <GridContainer>
      <div className={sellingPoints._}>
        <div className={sellingPoints.mainText._}>
          <Heading
            description={description}
            headline={headline}
            level={isTopOfPage ? 1 : 2}
            size={'xl'}
          />
          {cta && <div className={sellingPoints.mainText.cta}>{cta}</div>}
        </div>
        <div className={sellingPoints.list._}>
          {selling_points.map((sp) => (
            <div className={sellingPoints.list.item._} key={sp.headline}>
              <div>
                <div
                  className={
                    sellingPoints.list.item.iconContainer[
                      calcBgAndFontColor(sp.icon_background_color.select_theme ?? 'White')
                        .bgColorKey
                    ]
                  }
                >
                  {sp.icon.icon && (
                    <SvgIcon name={getSvgIconName(sp.icon.icon)} size={24} strokeWidth={3} />
                  )}
                </div>
              </div>
              <div>
                {isTopOfPage && <h2 className={sellingPoints.list.item.headline}>{sp.headline}</h2>}
                {!isTopOfPage && (
                  <h3 className={sellingPoints.list.item.headline}>{sp.headline}</h3>
                )}
                <p className={sellingPoints.list.item.description}>{sp.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </GridContainer>
  )
}
